import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { RootState } from '~/store';
import useMarketConfig from '~/hooks/useMarketConfig';
import { Group, H7, Icon, Label } from '@qred/components-library';
import useModals from '~/hooks/useModals';
import useTranslate from '~/hooks/useTranslate';
import OwnerManagementModal from './OwnerManagementModal';
import { IBeneficialOwner } from '~/interfaces/shared';
import { trackCardOfferActions } from '~/store/actions/analyticsActions';

interface AdditionalOwnerProps {
  owner: IBeneficialOwner;
}

const AdditionalOwner = ({ owner }: AdditionalOwnerProps) => {
  const dispatch = useAppDispatch();

  const {
    matchedMedia: { mobile },
  } = useSelector((state: RootState) => state);

  const t = useTranslate();
  const modals = useModals();
  const { marketHasPersonalNumber } = useMarketConfig();

  const openOwnerManagementModal = () => {
    dispatch(
      trackCardOfferActions({
        actionName: 'card_offer_edit_owner',
      })
    );

    modals.openModal({
      header: <H7>{t('OnboardingOffer.EditOwner')}</H7>,
      children: (
        <OwnerManagementModal
          initialOwner={owner}
          isAlternativeBeneficialOwner={owner.isAlternativeBeneficialOwner}
          askForPersonalNumber={marketHasPersonalNumber}
          askForDateOfBirth={!marketHasPersonalNumber}
        />
      ),
      size: 'md',
      fullScreen: mobile,
      filledBackground: true,
      hasOwnFooter: true,
    });
  };

  return (
    <Group justify="space-between">
      <Label size="lg">
        {owner.fullName}
        {!owner.isAlternativeBeneficialOwner && <> ({owner.percentage}%)</>}
      </Label>
      <Icon src="Pen" onClick={openOwnerManagementModal} />
    </Group>
  );
};

export default AdditionalOwner;
